interface Props {
  value: number;   // 0–1
  color?: string;
  height?: number;
  showLabel?: boolean;
}

export function ConfidenceBar({ value, color = '#00C8FF', height = 4, showLabel = false }: Props) {
  const pct = Math.min(100, Math.max(0, Math.round(value * 100)));
  return (
    <div className="flex items-center gap-2" style={{ minWidth: 0 }}>
      <div
        style={{ height, background: '#0F1928', borderRadius: height }}
        className="flex-1 overflow-hidden"
      >
        <div
          style={{
            width: `${pct}%`,
            height,
            background: color,
            borderRadius: height,
            transition: 'width 0.4s ease',
          }}
        />
      </div>
      {showLabel && (
        <span style={{ color, fontSize: 10, fontFamily: 'monospace', minWidth: 28, textAlign: 'right', fontWeight: 700 }}>
          {pct}%
        </span>
      )}
    </div>
  );
}
